import { render, staticRenderFns } from "./AddTriggerFile.vue?vue&type=template&id=64828abc&scoped=true&"
import script from "./AddTriggerFile.vue?vue&type=script&lang=js&"
export * from "./AddTriggerFile.vue?vue&type=script&lang=js&"
import style0 from "./AddTriggerFile.vue?vue&type=style&index=0&id=64828abc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64828abc",
  null
  
)

export default component.exports